import React, { useState } from "react";
import { Get, Remove, Set } from "../../../../../Request";

export const useRegion = () => {
  const [provinec, setProvinec] = useState([]);
  const [citys, setCitys] = useState([]);
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({});
  const getProvince = async () => {
    setLoading(true);

    return await Get({
      url: "/item/nes_data",
    }).then(data => {
      setLoading(false);
      if (data) {
        setProvinec(data.Provinces);
      }
    });
  };

  const getCity = async id => {
    setLoading(true);
    setForm({ ...form, province_id: id });
    return await Get({
      url: "/city/show",
      data: { province_id: id },
    }).then(data => {
      setLoading(false);

      if (data) {
        setCitys(data);
      }
    });
  };
  const getRegion = async id => {
    setLoading(true);
    setForm({ ...form, city_id: id });
    return await Get({
      url: "/region/show",
      data: { city_id: id },
    }).then(data => {
      setLoading(false);
      if (data) {
        setRegions(data);
      }
    });
  };
  return {
    loading,
    citys,
    regions,
    provinec,
    getProvince,
    getRegion,
    getCity,
    setForm,
    form,
  };
};
